
import { IState } from "../../../../../common";
import { SportModel } from "../../..";
import { BFFGateway, SportsResponse, Sport } from "sb-resp-lib";
import { SportsMapper } from "../../../mapper";
import { SportBFFQueryFactory, SportApiQueryFactory } from "../../../queries";
import { SportPushesRetriever } from "../..";

export class SportsBaseRetriever {

    private readonly gateway: BFFGateway;
    private readonly sportsMapper: SportsMapper;
    private readonly pushesRetriever: SportPushesRetriever;

    private sportRefreshTimer: number;
    private refreshInterval: number;
    private isActive: boolean;

    constructor (gateway: BFFGateway, sportsMapper: SportsMapper, pushesRetriever: SportPushesRetriever, refreshInterval: number) {
        this.gateway = gateway;
        this.sportsMapper = sportsMapper;
        this.pushesRetriever = pushesRetriever;
        this.refreshInterval = refreshInterval;
        this.sportRefreshTimer = -1;
        this.isActive = false;
    }

    activate() {
        this.isActive = true;
    }

    async refresh(state: IState<SportModel>, sportBffQueryFactory: SportBFFQueryFactory, sportApiQueryFactory: SportApiQueryFactory) {
        clearTimeout(this.sportRefreshTimer);
        return this.refreshInternal(state, sportBffQueryFactory, sportApiQueryFactory);
    }

    private async refreshInternal(state: IState<SportModel>, sportBffQueryFactory: SportBFFQueryFactory, sportApiQueryFactory: SportApiQueryFactory) {
        this.pushesRetriever.unsubscribe();
        const response = await this.getSports(sportBffQueryFactory);
        if (this.isActive && response.sports) {
            this.setSports(state, response.sports, sportApiQueryFactory);
            if (this.refreshInterval > 0) {
                this.sportRefreshTimer = window.setTimeout(() => this.refreshInternal(state, sportBffQueryFactory, sportApiQueryFactory), this.refreshInterval);
            }
        }
    }

    private async getSports(queryProvider: SportBFFQueryFactory): Promise<SportsResponse> {
        try {
            return await this.gateway.getSports(queryProvider());
        }
        catch {
            return { sports:[] };
        }
    }

    private setSports(state: IState<SportModel>, sports: Sport[], sportApiQueryFactory: SportApiQueryFactory)
    {
        if (sports && sports.length > 0) {
            const notSports = state.Items.filter(x => x.type !== "sports");
            const newSports = this.sportsMapper.map(sports);
            const newItems = notSports.concat(newSports);
            state.replaceItems(newItems);
            this.pushesRetriever.subscribe(state, sportApiQueryFactory);
        }
    }

    deactivate() {
        this.isActive = false;
        clearTimeout(this.sportRefreshTimer);
        this.pushesRetriever.unsubscribe();
    }
}